import { useCallback } from "react";
import { getDataFormByKey } from "../helpers/formCommentsHelpers";


export const useFormList = (form) => {


    const updateChecked = useCallback(
        ({ nameList, updateRefChecked, updateButtonsByForm, items }) => {
            const { key, data } = getDataFormByKey(form)

            let newStates = [];
            if (key === nameList && !data) {
                updateRefChecked(newStates)
                updateButtonsByForm(newStates)
                return
            }

            if (nameList === "comentarios" && data.length === 1) {
                const isInitComment = data.reduce((prev, acurrent) => acurrent?.comment === "", false)
                if (isInitComment) {
                    updateRefChecked([false])
                    updateButtonsByForm([false])
                    return
                }
            }

            updateRefChecked(data.map((check) => (check.reason.length === items)))
            updateButtonsByForm(new Array(data.length).fill(true))
        },
        [form],
    )

    const updateFormByChecked = ({ idChild = 0, items = [] }) => {
        const { key, data } = getDataFormByKey(form)
        const updatedFormValues = {
            [key]: data.map((item, index) => {
                let dataInput = {
                    _id: item?._id || null,
                    comment: item?.comment || "",
                    reason: item?.reason || [],
                };
                if (index === idChild) {
                    dataInput.reason = items;
                }
                return dataInput;
            }),
        };
        form.setFieldsValue(updatedFormValues);
    };

    const updateInitForm = ({ value, updateSelectAndButtons, }) => {
        const { key, data } = getDataFormByKey(form)
        if (data.length > 0) return
        updateSelectAndButtons({ value: false, idChild: 0 })
        form.setFieldsValue({
            [key]: value
        });
    }

    return {
        updateChecked,
        updateFormByChecked,
        updateInitForm

    }
}
